import currency from "currency.js"

const appCurrency = (value: currency.Any) => {
    return currency(
        value,
        {decimal:",",separator:".",symbol: ""})
}

export default appCurrency